<template>
  <div class="col-12">
    <transition mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: "ClubeVantagens",
  data() {
    return {
      produto: [
        {
          nome: "Clube de Vantagens",
          id: "ClubeVantagens",
        },
      ],
    };
  },
  methods: {},
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    if (this.$router.currentRoute.path === "/produto/clube-vantagens") {
      this.$router.push({ name: "clube-painel" });
    }
  },
};
</script>
